import { colors } from "../../configs";

const navbarcss = {
  navbar: {
    paddingTop: "10px",
    height: "50px",
    backgroundColor: "transparent",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    width: "100%",
    paddingBottom: "10px",
    zIndex: 5,
  },

  navContainer: {
    color: "white",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 1,
    padding: "5px",
  },

  logo: {
    fontSize: "4.5vw",
    fontWeight: "800",
  },
  navItems: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: "20px",
  },

  navButton: {
    right: 0,
    backgroundColor: "#3B82F6",
    border: "none",
    padding: "5px 5px",
    cursor: "pointer",
    color: "#ffffff",
    borderRadius: "5px",
    fontWeight: "400",
  },

  support: {
    width: "20px",
    height: "20px",
    color: "#ffffff",
    border: "1px solid #ffffff",
    backgroundColor: "transparent",
    padding: "5px",
    borderRadius: "50%",

    "&: hover": {
      color: "#ffffff",
      border: "1px solid #ffffff",
      fontWeight: "bolder",
      borderRadius: "2rem",
      backgroundColor: "black",
    },
  },
  authBtn: {
    "&: hover": {
      backgroundColor: colors.main,
      color: "#FFFFFF",
    },
  },
};
export default navbarcss;
